/** @format */

import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Search } from '../search';
import useQuery from 'src/hooks/useQuery';
import { useTranslation } from 'react-i18next';

export const KnowledgeBaseSearch = ({ kb }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const query = useQuery().get('query');
  const [keyword, setKeyword] = useState(query ? query : '');

  const onSubmit = () => {
    if (keyword) navigate(`/knowledge-base/${kb}/?query=${encodeURI(keyword)}`);
    else navigate(`/knowledge-base/${kb}`);
  };

  return <Search keyword={keyword} onChange={e => setKeyword(e.target.value)} onSubmit={onSubmit} />;
};
